export const search = {
  'Top Result': 'Resultado más relevante',
  Songs: 'Canciones',
  Playlists: 'Playlists',
  // 'No results': 'No results',
  // 'No results where found for': 'No results where found for',
  'No results': 'No se encontraron resultados',
  'No results where found for': 'No se encontraron resultados para',
};
